module.exports = __webpack_public_path__ + "static/crab-1-44d43cd5f7a340f9a81d94b2163d996a.png";